import * as React from 'react';
import NotificationModel from '../../application/core/Notification';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import State from '../../application/core/State';
import './Notifications.css';
import Notification from './Notification';
import notificationFilter from './NotificationFilter';

interface StateProps {
    notifications: NotificationModel[];
}

class Notifications extends React.PureComponent<StateProps & DispatchProps> {
    public render(): JSX.Element | null {
        return this.getNotifications().length > 0 ? (
            <div className="notifications">
                {this.getNotifications().map((notification: NotificationModel) => (
                    <Notification key={notification.id} notification={notification} />
                ))}
            </div>
        ) : null;
    }

    private getNotifications = (): NotificationModel[] =>
        notificationFilter(this.props.notifications.filter((notification: NotificationModel) => notification.data.event === undefined));
}

const mapStateToProps = (state: State): StateProps => ({
    notifications: state.notifications
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/view/notifications/Notifications.tsx